import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "@/pages/home/components/Hero";
import About from "@/pages/home/components/About";
import Marquee from "@/pages/home/components/Marquee";
import Films from "@/pages/home/components/Films";
import Players from "@/pages/home/components/Players";
import News from "@/pages/home/components/News";
import Support from "@/pages/home/components/Support";
import Contact from "@/pages/home/components/Contact";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Marquee />
        <Films />
        <Players />
        <News />
        <Support />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}